// 缓存浏览器 快捷方法 
// 已添加到全局方法 直接使用   this.$storage.get()  this.$session.get() 


// 永久缓存
export const storageHandle = {
  set (key, value, type = 'local') {
    if (type == 'local') {
      // 永久缓存  默认
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      // 会话式缓存
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  },
  get (key, type = 'local') {
    if (type == 'local') {
      return JSON.parse(localStorage.getItem(key));
    } else {
      return JSON.parse(sessionStorage.getItem(key));
    }
  },
  remove (key, type = 'local') {
    if (type == 'local') {
      localStorage.removeItem(key)
    } else {
      sessionStorage.removeItem(key)
    }
  }
}

// 会话式缓存
export const sessionHandle = {
  set (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  get (key) {
    return JSON.parse(sessionStorage.getItem(key));
  },
  remove (key) {
    sessionStorage.removeItem(key)
  }
}